export default {
  isLoggedIn (state) {
    return !!state.token
  }
}
